import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';

import { finalize } from "rxjs/operators";
import { LoadersService } from './loaders.service';
import { PagesService } from '../../pages.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'

})
export class LoaderInterceptor implements HttpInterceptor  {
  private totalRequests = 0; 
  currentUser:any;
  userInactive:any;
  serviceApiUrl:string;
  constructor(private loader: LoadersService, public pagesService:PagesService,private _router: Router) {

  }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // console.log('caught')
    // console.log('caught',request.url)
    if (request.url.includes('/qubes-user/sentOtpToMail?userName=') || 
        request.url.includes('/qubes-user/getByUserName?userName=') ||
        request.url.includes('/qubes-user/validateOtpFromMail?userName=') ||
        request.url.includes('/scheduleMaintenance/sentOtpToMail?id=') ||
        request.url.includes('/smreplan/sentOtpToMail?id=') ||
        request.url.includes('/scheduleMaintenance/validateOtpFromMailApprove?otp=') ||
        request.url.includes('/scheduleMaintenanceSp/validateOtpFromMailApprove?otp=') ||
        request.url.includes('/scheduleMaintenanceSp/validateOtpFromMailReject?otp=') ||
        request.url.includes('/scheduleMaintenance/validateOtpFromMailReject?otp=') ||
        request.url.includes('/smreplan/validateOtpFromMailApprove?otp=') ||
        request.url.includes('/tsd/mailApproval') ||
        request.url.includes('/tsd/mailApprovalSP') ||
        request.url.includes('/tsd/mailRejectSP') ||
        request.url.includes('/tsd/mailApprovalReplan') ||
        request.url.includes('/tsd/mailReject')||
        request.url.includes('/qubes-user-group-menu-mapping/group-id') ){
      // console.log('true')
    } else {
      this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      // console.log('false')
    }
    // console.log('current User',this?.currentUser)
    this.serviceApiUrl = environment.serviceApiUrl;
    this.totalRequests++;
    this.loader.setLoading(true);
    // console.log(this.loader.getLoading(),'true or false')
    if (request.url.includes('/notificationview/findByUserId?userId=') || 
    request.url.includes('/qubes-user/check-user-session?userId=') ||
    request.url.includes('/qubes-user/checkLogout?userLoginDetailId=') ||
    request.url.includes('/qubes-user/getByUserName?userName=') ||
    request.url.includes('/qubes-user/sentOtpToMail?userName=') ||
    request.url.includes('/smreplan/sentOtpToMail?id=') ||
    request.url.includes('/qubes-user/validateOtpFromMail?userName=') ||
    request.url.includes('/scheduleMaintenance/sentOtpToMail?id=') ||
    request.url.includes('/scheduleMaintenance/validateOtpFromMailApprove?otp=') ||
    request.url.includes('/scheduleMaintenanceSp/validateOtpFromMailApprove?otp=') ||
    request.url.includes('/scheduleMaintenanceSp/validateOtpFromMailReject?otp=') ||
    request.url.includes('/smreplan/validateOtpFromMailApprove?otp=') ||
    request.url.includes('/scheduleMaintenance/validateOtpFromMailReject?otp=') ){
    // console.log('which url',request.url.startsWith)
    }else{
      // console.log('nadakudha ilaya')
      this.pagesService.checkUserActivity(this.currentUser.id).subscribe(x=>{
        this.userInactive = []
        this.userInactive = x
      }, (err: any) => {
        if (err.status === 403) {
          this.pagesService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{ }) 
          sessionStorage.removeItem('currentUser');
          this._router.navigate(['/auth/login']);
          Swal.fire('','Session timed out','warning')
        }
      })
    }
    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loader.setLoading(false);
        }
      })
    );
  }

//   intercept(req: HttpRequest<any>, next: HttpHandler) {
//     this.loader.setLoading(true)
//     return next.handle(req).pipe(
//       finalize(() => this.loader.setLoading(false))
//     );

//   }
}